import "../styles/demand.css";
import cloudDemandImg from "../assets/cloud-demand-chart.png";

export default function CloudDemand() {
  return (
    <section className="demand-section">

      {/* HEADER */}
      <div className="demand-header">
        <h2>
          Industry Demand <span>2025 – 2026</span>
        </h2>

        <p>
          Strong and consistent demand for Cloud Computing professionals across
          startups, enterprises, SaaS companies, and global organizations.
        </p>
      </div>

      {/* IMAGE */}
      <div className="demand-image-wrapper">
        <img
          src={cloudDemandImg}
          alt="Cloud Computing Job Demand 2025-2026"
        />
      </div>

    </section>
  );
}
